import React from "react";


import createIcon from "../../icons/add_circle_FILL0_wght200_GRAD0_opsz40.svg";


import { useSelector } from "react-redux";
import {Link, useRouteMatch } from "react-router-dom";
import LoadingCards from "../../Loading/LoadingCards";

import loadable from '@loadable/component';
import CardNav from "../../UI/CardNav";
const ArrCards= [1,2,3,4,5,6,7,8,9];
let lazyLoad =   <LoadingCards cards={ArrCards} type="ExtraSmallCard"/>;
const Card = loadable(() => import("../../UI/Card"), {
  fallback: lazyLoad  });
const ProfileCards=({baseUrl})=>{
  
  const userdata = useSelector((state)=>state?.user?.user);
    const {url} =useRouteMatch();
    
return(<>

{userdata?.change_password? 
  <Link   to="/addNewPassWord">
<CardNav  icon={createIcon} alt="addNewPassWord" title="Change Password"  >

</CardNav>
</Link>
 :   <></>  }
  
   <Link to={`${url}/user-details`} >
   <Card  icon={createIcon} alt="create" title="User Details"  >

    </Card>
   </Link> 

   <Link to={`${url}/social-profiles`} >
   <Card  icon={createIcon} alt="create" title="Social Profiles"  >

    </Card>
   </Link> 
   <Link to={`${url}/address`} >
   <Card  icon={createIcon} alt="create" title="Address"  >

    </Card>
   </Link> 
   <Link to={`${url}/education`} >
   <Card  icon={createIcon} alt="create" title="Education"  >

    </Card>
   </Link> 
   
   <Link to={`${url}/career-development`} >
   <Card  icon={createIcon} alt="create" title="Career Development"  >

    </Card>
   </Link> 
   
   <Link to={`${url}/my-skills`} >
   <Card  icon={createIcon} alt="create" title="My Skills"  >

    </Card>
   </Link> 
   
   <Link to={`${url}/work-experience`} >
   <Card  icon={createIcon} alt="create" title="Work Experience"  >

    </Card>
   </Link>  <Link to={`${url}/certificates`} >
   <Card  icon={createIcon} alt="create" title="Certifications"  >

    </Card>
   </Link>  
   <Link to={`${url}/my-projects`} >
   <Card  icon={createIcon} alt="create" title="My Projects"  >

    </Card>
   </Link> 
   <Link to={`${url}/privacy`} >
   <Card  icon={createIcon} alt="create" title="User Settings"  >

    </Card>
   </Link> 
   


</>)
}
export default ProfileCards